import { Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import i18n from '../../i18n/i18next'

export const NoOrg = () => {
    return (
        <Stack
            height={'100%'}
            direction={'column'}
            justifyContent={'center'}
            width={'100%'}
        >
            <Typography id="noTeamText" variant="bodyBold" textAlign={'center'}>
                {i18n.t('account.noTeam')}
            </Typography>
            <Typography
                id="headToAccountPageText"
                variant="bodyRegular"
                textAlign={'center'}
            >
                {i18n.t('account.noTeamCreate')}
            </Typography>
        </Stack>
    )
}
